import { graphql, useStaticQuery } from 'gatsby';

export const useZoneSections = () => {
  const { wrapper } = useStaticQuery(graphql`
    query {
      wrapper: allAirtableBlocks(sort: {fields: rowIndex}) {
        nodes {
          data {
            Key
            Section
            ShowTitle
            Source
            Type
            Value
          }
        }
      }
    }
  `);

  return wrapper.nodes;
};

export default useZoneSections;
